import { defineComponent as _defineComponent } from 'vue'
import Tooltip from "../../tooltip/Tooltip.vue";
import vuetify from "../../../service/useVuetify";


export default /*#__PURE__*/_defineComponent({
  __name: 'SupportContact',
  props: {
    mini: { type: Boolean },
    email: null,
    emailTooltip: null,
    phoneTooltip: null,
    phone: null
  },
  setup(__props: any) {



return { __sfc: true,Tooltip, vuetify }
}

})